import React from 'react';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import './scss/EmojiPicker.scss';

const EmojiPicker = ({ onEmojiSelect }) => {
    return (
        <div className="emoji-picker-content">
            <Picker
                data={data}
                onEmojiSelect={onEmojiSelect}
                theme="light"
                set="native"
                previewPosition="none"
                skinTonePosition="none"
                searchPosition="sticky"
                navPosition="top"
                perLine={9}
                maxFrequentRows={2}
            />
        </div>
    );
};

export default EmojiPicker;
